const formatNumber = (value, decimalPlaces) => {
  if (!value) {
    return "0";
  }

  return value.toLocaleString("en-US", {
    maximumFractionDigits: decimalPlaces || 2,
  });
};

export default formatNumber;
